import { render, staticRenderFns } from "./RegisterBox.vue?vue&type=template&id=f0446d96"
import script from "./RegisterBox.vue?vue&type=script&lang=js"
export * from "./RegisterBox.vue?vue&type=script&lang=js"
import style0 from "./RegisterBox.vue?vue&type=style&index=0&id=f0446d96&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports